<template>
  <v-container
    v-if="assessments"
    class="white"
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      align-center
      row
      wrap
    >
      <v-flex xs10>
        <h2>SAMM Model</h2>
      </v-flex>
      <v-flex
        xs2
        align-end
      >
        <v-btn
          class="mx-2 hidden-print-only"
          fab
          dark
          @click="print"
        >
          Print
        </v-btn>
      </v-flex>
      <v-flex
        v-if="client"
        class="hidden-screen-only"
        xs6
      >
        Client: {{ client.name }}
      </v-flex>
      <v-flex
        v-if="assessment"
        class="hidden-screen-only"
        xs6
      >
        {{ assessment.name }}
      </v-flex>
      <v-flex
        class="hidden-print-only"
        xs6
      >
        <v-select
          v-model="clientId"
          :items="clients"
          item-text="name"
          item-value="id"
          label="Client"
        />
      </v-flex>
      <v-flex
        class="hidden-print-only"
        xs6
      >
        <v-select
          v-model="assessmentIds"
          :items="clientAssessment"
          item-text="text"
          item-value="id"
          label="Assessment"
          multiple
        />
      </v-flex>
      <v-row no-gutters>
        <v-col cols="2" style="margin-right: 60px; margin-top: -100px;"
          v-if="metricTotal"
          xs2
        >
          <graph-metric
            :metric="metricTotal"
            :reversed="true"
            colour="#1a9abc"
            :completed="2"
            description="Nonexistent"
            icon="mdi-flip-to-front"
          />
        </v-col>
        <v-col cols="2" style="margin-right: 60px; margin-top: -100px;"
          v-if="metricCompliance"
          xs2
        >
          <graph-metric
            :metric="metricCompliance"
            colour="#f9a01f"
            description="Compliance Focussed"
            icon="mdi-check-outline"
          />
        </v-col>
        <v-col cols="2" style="margin-right: 60px; margin-top: -100px;"
          v-if="metricBehaviour"
          xs2
        >
          <graph-metric
            :metric="metricBehaviour"
            colour="#cc3a3d"
            :completed="2"
            description="Behavior Change"
            icon="mdi-lightbulb-on-outline"
          />
        </v-col>
        <v-col cols="2" style="margin-right: 60px; margin-top: -100px;"
          v-if="metricAmbassador"
          xs2
        >
          <graph-metric
            :metric="metricAmbassador"
            colour="#169b8b"
            :completed="2"
            description="Culture Change"
            icon="mdi-account-group-outline"
          />
        </v-col>
        <v-col cols="2" style="margin-right: 60px; margin-top: -100px;"
          v-if="metricStrategic"
          xs2
        >
          <graph-metric
            :metric="metricStrategic"
            colour="#169b8b"
            :completed="2"
            description="Strategic"
            icon="mdi-account-group-outline"
          />
        </v-col>
        <v-col cols="2" style="margin-right: 60px; margin-top: -100px;"
          v-if="metricTotal"
          xs2
        >
          <graph-metric
            :metric="metricTotal"
            colour="#115a82"
            :completed="2"
            description="Metrics Framework"
            icon="mdi-timeline-clock"
          />
        </v-col>
      </v-row>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import _ from 'lodash';
import GraphMetric from '../../components/graph-metric';
import assessmentItems from '../../mixins/assessmentItems';
import formatting from '../../mixins/formatting';

export default {
  components: {
    GraphMetric,
  },
  mixins: [formatting, assessmentItems],
  data: () => ({
    clientId: null,
    assessmentId: null,
    assessmentIds: [],
    headers: [
      {
        sortable: true,
        text: 'Metric',
        value: 'name',
      },
      {
        sortable: true,
        text: 'Progress',
        value: 'progress',
      },
      {
        sortable: true,
        text: 'Requests',
        value: 'totalRequest',
      },
      {
        sortable: true,
        text: 'Responses',
        value: 'totalResponse',
      },
      {
        sortable: true,
        text: 'Success',
        value: 'totalSuccess',
      },
      {
        sortable: true,
        text: 'Frequency',
        value: 'when',
      },
      {
        sortable: true,
        text: 'Responsible Role',
        value: 'who',
      },
    ],
  }),
  computed: {
    ...mapGetters('odata', ['assessments']),
    ...mapGetters('odata', ['clients']),
    ...mapGetters('odata', ['assessmentItems']),
    ...mapGetters('assessments', ['reportAssessmentItems']),
    ...mapState('assessments', ['reportMetrics']),
    client() {
      return _.find(this.clients, c => c.id === this.clientId);
    },
    assessment() {
      return _.find(this.assessments, c => c.id === this.assessmentId);
    },
  },
  watch: {
    assessmentIds() {
      this.loadMultipleReportMetrics(this.assessmentIds);
    },
  },
  created() {
    this.clearReportMetrics();
    this.$store.dispatch('odata/load.assessments');
    this.$store.dispatch('odata/load.clients');
  },
  methods: {
    ...mapActions('assessments', ['clearReportMetrics', 'loadMultipleReportMetrics']),
    print() {
      window.print();
    },
  },
};
</script>
